import firebase from "firebase/app";

const { Timestamp } = firebase.firestore

export const INVITE_EXPIRATION_TIME = 1

export function addDays(date: Date, days: number) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function getinviteExpirationTimestamp() {
    return Timestamp.fromDate(addDays(Timestamp.now().toDate(), INVITE_EXPIRATION_TIME))
}
